import { useHistory } from 'react-router-dom';

const PageTitle = ({ titles }) => {

    const history = useHistory();

    const goTo = (goBackTo) => {
        history.replace(goBackTo);
        // history.(goBackTo)
    }

    return (
        <div className="tw-mb-10 tw-text-2xl tw-ml-8 tw-mt-14">
            {
                titles.map((title, idx)=> {
                    if (idx == titles.length - 1) {
                        return <span key={idx} className="tw-text-azulescuro" >{title}</span>
                    } else {
                        if (typeof title == 'string'){
                            return <span key={idx} className="tw-text-[#8A8A8A] tw-pr-2 tw-mr-2 tw-border-r-2 tw-border-r-[#8A8A8A]">{title}</span>
                        } else 
                        return <span key={idx} onClick={() => goTo(title.route)} className="tw-text-[#8A8A8A] tw-cursor-pointer hover:tw-text-azulescuro tw-pr-2  tw-mr-2 tw-border-r-2 tw-border-r-[#8A8A8A]">{title.label}</span> 
                    }
                })
            }
            </div>
    )
}

export default PageTitle;
